import { Component, Input, OnDestroy, OnInit } from '@angular/core'
import { map, tap, timeout } from 'rxjs/operators'
import { CatalogueService } from '../../../../../../services/catalogue.service'
import { InlineEditCellDirective } from '../inline-edit-cell'
import { Observable, Subscription } from 'rxjs'

@Component({
  selector: 'jml-lib-icon-cell',
  templateUrl: './icon-cell.component.html',
  styleUrls: ['../inline-edit-cell.scss']
})
export class IconCellComponent extends InlineEditCellDirective implements OnInit, OnDestroy {
  @Input() catalogueHrid: string
  @Input() header = ''
  options$?: Observable<any[]>

  // is needed because getCatalogue is buggy and we need to subscribe immediately
  options: any[] = []
  private subscription: Subscription

  constructor(private catalogueService: CatalogueService) {
    super()
  }

  ngOnInit(): void {
    const catalogue$ = !!this.catalogueHrid ? this.catalogueService.getCatalogue(this.catalogueHrid) : undefined
    if (!!catalogue$) {
      // if catalogue found
      this.options$ = catalogue$.pipe(
        map((catalogue) =>
          catalogue.values.map((catalogueEntry) => {
            return { label: catalogueEntry.name, value: catalogueEntry }
          })
        )
      )
      this.subscription = this.options$.subscribe((options) => (this.options = options))
    }
  }

  triggerEdit() {
    this.originalContent = this.rowData[this.fieldName]
    setTimeout(() => {
      this.isEdited = true
    }, 0)
  }

  ngOnDestroy(): void {
    if (!!this.subscription) {
      this.subscription.unsubscribe()
    }
  }
}
